/* Avalna Cart & Trust — Batch 04 (updated 14, 20A) */

(function AvalnaCartTrust() {
  'use strict';

  /* ---------- NAMESPACE ---------- */
  window.Avalna = window.Avalna || {};
  window.Avalna.cartTrust = {};

  /* ---------- HELPERS ---------- */

  function avalnaQs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function avalnaQsa(sel, root) {
    return (root || document).querySelectorAll(sel);
  }

  /* ---------- DATA BOOTSTRAP ---------- */

  var avalnaDataEl = avalnaQs('[data-avalna-cart-trust-data]');
  var avalnaCartData = null;
  if (avalnaDataEl) {
    try {
      avalnaCartData = JSON.parse(avalnaDataEl.textContent);
    } catch (e) {
      console.warn('[Avalna] Could not parse cart trust data');
    }
  }

  var avalnaRecsCache = {};
  var avalnaLastRecsProductId = null;

  /* --- Free Shipping Progress Bar --- */

  function avalnaInitShippingBar() {
    var barInit = avalnaQs('[data-avalna-shipping-bar]');
    if (!barInit) return;

    var threshold = parseInt(barInit.getAttribute('data-avalna-shipping-threshold'), 10) || 1000;
    if (threshold === 0) return;

    function avalnaUpdateShippingBar(totalCents) {
      var bar = avalnaQs('[data-avalna-shipping-bar]');
      if (!bar) return;

      var totalRupees = totalCents / 100;
      var remaining = threshold - totalRupees;
      var pct = Math.min(100, (totalRupees / threshold) * 100);

      var textEl = avalnaQs('[data-avalna-shipping-text]', bar);
      var fillEl = avalnaQs('[data-avalna-shipping-fill]', bar);
      var truckSvg = avalnaQs('.avalna-cart-shipping-bar__truck', bar);
      var checkSvg = avalnaQs('.avalna-cart-shipping-bar__check', bar);

      if (fillEl) {
        fillEl.style.width = pct + '%';
      }

      if (totalRupees >= threshold) {
        bar.setAttribute('data-avalna-shipping-celebrate', 'true');
        if (textEl) textEl.innerHTML = '🎉 You\'ve earned <strong>FREE shipping!</strong>';
        if (truckSvg) truckSvg.style.display = 'none';
        if (checkSvg) checkSvg.style.display = '';
      } else {
        bar.setAttribute('data-avalna-shipping-celebrate', 'false');
        if (textEl) textEl.innerHTML = 'Add <strong>₹' + Math.ceil(remaining) + '</strong> more for <strong>FREE shipping!</strong>';
        if (truckSvg) truckSvg.style.display = '';
        if (checkSvg) checkSvg.style.display = 'none';
      }

    }

    if (avalnaCartData) {
      avalnaUpdateShippingBar(avalnaCartData.cartTotalCents);
    }

    avalnaOnCartUpdate(function (cartJson) {
      avalnaUpdateShippingBar(cartJson.total_price);
    });

    window.Avalna.cartTrust.updateShippingBar = avalnaUpdateShippingBar;
  }

  /* --- Estimated Delivery --- */

  function avalnaAddBusinessDays(date, days) {
    var result = new Date(date);
    var added = 0;
    while (added < days) {
      result.setDate(result.getDate() + 1);
      var day = result.getDay();
      if (day !== 0 && day !== 6) {
        added++;
      }
    }
    return result;
  }

  function avalnaCalculateDelivery() {
    var el = avalnaQs('[data-avalna-cart-delivery]');
    if (!el) return;

    var minDays = 5;
    var maxDays = 7;

    if (avalnaCartData && avalnaCartData.items && avalnaCartData.items.length > 0) {
      var allMin = [];
      var allMax = [];
      for (var i = 0; i < avalnaCartData.items.length; i++) {
        allMin.push(avalnaCartData.items[i].minDays || 5);
        allMax.push(avalnaCartData.items[i].maxDays || 7);
      }
      minDays = Math.min.apply(null, allMin);
      maxDays = Math.max.apply(null, allMax);
    }

    /* Batch 30B: minDays/maxDays are BUSINESS days, so weekends must be
       skipped. This previously added raw calendar days, which promised
       delivery ~3 days earlier than the PDP and could land on a Saturday.
       Mirrors avalnaAddBusinessDays in avalna-pdp-conversion.js — keep the
       two in step or the drawer and the product page will disagree again. */
    var now = new Date();
    var dateMin = avalnaAddBusinessDays(now, minDays);
    var dateMax = avalnaAddBusinessDays(now, maxDays);

    var opts = { weekday: 'short', day: 'numeric', month: 'short' };
    var datesEl = avalnaQs('[data-avalna-delivery-dates]');
    if (datesEl) {
      datesEl.textContent = dateMin.toLocaleDateString('en-IN', opts) + ' – ' + dateMax.toLocaleDateString('en-IN', opts);
    }

    el.style.display = '';
  }

  function avalnaInitDelivery() {
    avalnaCalculateDelivery();

    avalnaOnCartUpdate(function (cartJson) {
      var el = avalnaQs('[data-avalna-cart-delivery]');
      if (el) {
        el.style.display = cartJson.item_count > 0 ? '' : 'none';
      }
      setTimeout(avalnaCalculateDelivery, 100);
    });
  }

  /* --- Cart Notes --- */

  function avalnaSaveNote(note) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: note }),
      credentials: 'same-origin'
    }).catch(function () {
      console.warn('[Avalna] Failed to save cart note');
    });
  }

  /* --- Product Recommendations --- */

  function avalnaFetchRecommendations(productId) {
    var recsEl = avalnaQs('[data-avalna-cart-recs]');
    if (!recsEl) return;
    var scrollEl = avalnaQs('[data-avalna-recs-scroll]', recsEl);
    if (!scrollEl) return;

    if (productId === avalnaLastRecsProductId) return;
    avalnaLastRecsProductId = productId;

    if (avalnaRecsCache[productId]) {
      avalnaRenderRecommendations(avalnaRecsCache[productId], recsEl, scrollEl);
      return;
    }

    fetch('/recommendations/products.json?product_id=' + productId + '&limit=6', {
      credentials: 'same-origin'
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = data.products || [];
        avalnaRecsCache[productId] = products;
        avalnaRenderRecommendations(products, recsEl, scrollEl);
      })
      .catch(function () {
        var el = avalnaQs('[data-avalna-cart-recs]');
        if (el) el.style.display = 'none';
      });
  }

  function avalnaRenderRecommendations(products, recsEl, scrollEl) {
    if (!products || products.length === 0) {
      recsEl.style.display = 'none';
      return;
    }

    recsEl.style.display = '';
    var html = '';
    for (var i = 0; i < products.length; i++) {
      var p = products[i];
      var imgSrc = '';
      if (p.featured_image) {
        imgSrc = typeof p.featured_image === 'string' ? p.featured_image : (p.featured_image.src || '');
      } else if (p.images && p.images.length > 0) {
        var img0 = p.images[0];
        imgSrc = typeof img0 === 'string' ? img0 : (img0.src || '');
      }
      var price = p.price ? '₹' + (p.price / 100) : '';

      html += '<a href="/products/' + p.handle + '" class="avalna-cart-recs__card">';
      if (imgSrc) {
        html += '<img class="avalna-cart-recs__card-image" src="' + imgSrc + '" alt="' + avalnaEscapeHtml(p.title) + '" loading="lazy" width="100" height="100">';
      } else {
        html += '<div class="avalna-cart-recs__card-image"></div>';
      }
      html += '<p class="avalna-cart-recs__card-title">' + avalnaEscapeHtml(p.title) + '</p>';
      html += '<p class="avalna-cart-recs__card-price">' + price + '</p>';
      html += '</a>';
    }
    scrollEl.innerHTML = html;
  }

  function avalnaInitRecommendations() {
    if (!avalnaQs('[data-avalna-cart-recs]')) return;

    if (!avalnaCartData || !avalnaCartData.items || avalnaCartData.items.length === 0) {
      var el = avalnaQs('[data-avalna-cart-recs]');
      if (el) el.style.display = 'none';
    } else {
      avalnaFetchRecommendations(avalnaCartData.items[avalnaCartData.items.length - 1].id);
    }

    avalnaOnCartUpdate(function (cartJson) {
      if (cartJson.item_count === 0) {
        avalnaLastRecsProductId = null;
        var el = avalnaQs('[data-avalna-cart-recs]');
        if (el) el.style.display = 'none';
        return;
      }
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.items && data.items.length > 0) {
            avalnaFetchRecommendations(data.items[data.items.length - 1].product_id);
          }
        })
        .catch(function () {});
    });
  }

  /* --- Cart State Sync --- */

  function avalnaCheckEmptyState(itemCount) {
    var footer = avalnaQs('[data-avalna-cart-trust-footer]');
    if (!footer) return;
    if (itemCount === 0) {
      footer.classList.add('avalna-cart-empty');
    } else {
      footer.classList.remove('avalna-cart-empty');
    }

    var shippingBar = avalnaQs('[data-avalna-shipping-bar]');
    if (shippingBar) {
      shippingBar.style.display = itemCount > 0 ? '' : 'none';
    }
  }

  function avalnaInitStateSync() {
    if (avalnaCartData) {
      avalnaCheckEmptyState(avalnaCartData.itemCount);
    }

    avalnaOnCartUpdate(function (cartJson) {
      avalnaCheckEmptyState(cartJson.item_count);

      var subtotalEl = avalnaQs('[data-avalna-subtotal]');
      var totalEl = avalnaQs('[data-avalna-total]');
      if (subtotalEl) subtotalEl.textContent = avalnaFormatMoney(cartJson.total_price);
      if (totalEl) totalEl.textContent = avalnaFormatMoney(cartJson.total_price);

      avalnaUpdateDrawerHeaderCount(cartJson.item_count);

      document.dispatchEvent(new CustomEvent('cart:updated'));
    });
  }

  function avalnaFormatMoney(cents) {
    return 'Rs. ' + (cents / 100).toLocaleString('en-IN');
  }

  function avalnaUpdateDrawerHeaderCount(count) {
    var heading = avalnaQs('cart-drawer.avalna-cart-drawer .drawer__heading');
    if (!heading) return;
    if (count > 0) {
      heading.textContent = 'YOUR CART (' + count + ')';
    } else {
      heading.textContent = 'YOUR CART';
    }
  }

  /* --- Drawer Open Coordination --- */

  function avalnaInitDrawerCoordination() {
    document.addEventListener('submit', function avalnaOnFormSubmit(e) {
      var form = e.target;
      if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;

      setTimeout(function () {
        document.dispatchEvent(new CustomEvent('cart:updated'));
      }, 1000);
    });
  }

  /* --- Open Cart Drawer Programmatically --- */

  function avalnaOpenCartDrawer() {
    var cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return false;
    if (typeof cartDrawer.open === 'function') { cartDrawer.open(); return true; }
    return false;
  }

  window.Avalna.cartTrust.openDrawer = avalnaOpenCartDrawer;

  /* --- Cart Update Listener --- */

  var avalnaCartUpdateCallbacks = [];

  function avalnaOnCartUpdate(callback) {
    avalnaCartUpdateCallbacks.push(callback);
  }

  function avalnaFireCartUpdate(cartJson) {
    for (var i = 0; i < avalnaCartUpdateCallbacks.length; i++) {
      try {
        avalnaCartUpdateCallbacks[i](cartJson);
      } catch (e) {
        console.warn('[Avalna] Cart update callback error:', e);
      }
    }
  }

  /* --- Unified Cart Observer (Batch 14) --- */

  var avalnaToggleDetailsEl = null;
  var avalnaLastCartState = '';

  function avalnaSetupCartObserver() {
    var drawerEl = document.querySelector('cart-drawer');
    if (!drawerEl) return;

    var debounceTimer = null;

    function avalnaRefreshAfterMutation() {
      var newDataEl = avalnaQs('[data-avalna-cart-trust-data]');
      if (newDataEl) {
        try { avalnaCartData = JSON.parse(newDataEl.textContent); } catch (e) {}
      }
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cartJson) {
          var state = cartJson.item_count + ':' + cartJson.total_price;
          if (state !== avalnaLastCartState) {
            avalnaLastCartState = state;
            avalnaFireCartUpdate(cartJson);
          }
          avalnaCalculateDelivery();
          avalnaBindToggleListener();
        })
        .catch(function () {});
    }

    var observer = new MutationObserver(function () {
      if (debounceTimer) clearTimeout(debounceTimer);
      debounceTimer = setTimeout(avalnaRefreshAfterMutation, 300);
    });

    observer.observe(drawerEl, { childList: true, subtree: true });

    avalnaBindToggleListener();
  }

  /* Re-bind toggle listener after DOM replacement */
  function avalnaBindToggleListener() {
    var drawerEl = document.querySelector('cart-drawer');
    if (!drawerEl) return;
    var detailsEl = drawerEl.querySelector('details');
    if (!detailsEl || detailsEl === avalnaToggleDetailsEl) return;

    avalnaToggleDetailsEl = detailsEl;
    detailsEl.addEventListener('toggle', function () {
      if (!detailsEl.open) return;
      avalnaLastCartState = '';
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cartJson) {
          avalnaLastCartState = cartJson.item_count + ':' + cartJson.total_price;
          avalnaFireCartUpdate(cartJson);
        })
        .catch(function () {});
    });
  }

  /* --- Event Delegation (Batch 14) --- */

  function avalnaSetupDelegatedListeners() {
    var drawerEl = document.querySelector('cart-drawer');
    if (!drawerEl) return;

    var noteDebounce = null;

    drawerEl.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-avalna-notes-trigger]');
      if (trigger) {
        var notesEl = trigger.closest('[data-avalna-cart-notes]');
        if (notesEl) {
          var expanded = notesEl.getAttribute('data-avalna-notes-expanded') === 'true';
          notesEl.setAttribute('data-avalna-notes-expanded', expanded ? 'false' : 'true');
          trigger.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        }
        return;
      }

      var checkoutBtn = e.target.closest('.avalna-cart-checkout__btn');
      if (checkoutBtn && !checkoutBtn.disabled) {
        var form = document.getElementById('CartDrawer-Form');
        if (form) {
          e.preventDefault();
          var input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'checkout';
          input.value = '';
          form.appendChild(input);
          form.submit();
        }
        return;
      }

      if (e.target.id === 'CartDrawer-Overlay' || e.target.classList.contains('cart-drawer__overlay')) {
        if (typeof drawerEl.close === 'function') {
          drawerEl.close();
        }
      }
    });

    drawerEl.addEventListener('input', function (e) {
      if (!e.target.matches('[data-avalna-notes-textarea]')) return;
      if (noteDebounce) clearTimeout(noteDebounce);
      noteDebounce = setTimeout(function () {
        avalnaSaveNote(e.target.value);
      }, 500);
    });

    drawerEl.addEventListener('focusout', function (e) {
      if (!e.target.matches('[data-avalna-notes-textarea]')) return;
      if (noteDebounce) clearTimeout(noteDebounce);
      avalnaSaveNote(e.target.value);
    });
  }

  /* --- Utility --- */

  function avalnaEscapeHtml(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str || ''));
    return div.innerHTML;
  }

  /* --- Stock-Limited Add-to-Cart Recovery (Batch 20A) --- */

  function avalnaInitCartErrorRecovery() {
    if (typeof subscribe !== 'function') return;
    subscribe('cart-error', function () {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cartJson) {
          if (cartJson.item_count < 1) return;
          fetch(window.location.pathname + '?section_id=cart-drawer')
            .then(function (r) { return r.text(); })
            .then(function (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var freshDrawer = doc.querySelector('#CartDrawer');
              var liveDrawer = document.querySelector('#CartDrawer');
              if (freshDrawer && liveDrawer) {
                liveDrawer.innerHTML = freshDrawer.innerHTML;
              }
              var iconBubble = doc.querySelector('#cart-icon-bubble .shopify-section');
              var liveBubble = document.querySelector('#cart-icon-bubble');
              if (iconBubble && liveBubble) {
                liveBubble.innerHTML = iconBubble.innerHTML;
              }
              var drawerEl = document.querySelector('cart-drawer');
              if (drawerEl) {
                drawerEl.classList.remove('is-empty');
                if (typeof drawerEl.open === 'function') drawerEl.open();
              }
              avalnaLastCartState = '';
              avalnaFireCartUpdate(cartJson);
            });
        })
        .catch(function () {});
    });
  }

  /* --- Init --- */

  function avalnaInitCartTrust() {
    if (avalnaCartData) {
      avalnaUpdateDrawerHeaderCount(avalnaCartData.itemCount);
    }

    avalnaInitShippingBar();
    avalnaInitDelivery();
    avalnaInitRecommendations();
    avalnaInitStateSync();
    avalnaInitDrawerCoordination();
    avalnaInitCartErrorRecovery();
    avalnaSetupCartObserver();
    avalnaSetupDelegatedListeners();

    setTimeout(function avalnaDelayedInit() {
      if (avalnaCartData) {
        avalnaUpdateDrawerHeaderCount(avalnaCartData.itemCount);
      }
      var datesEl = avalnaQs('[data-avalna-delivery-dates]');
      if (datesEl && datesEl.textContent === 'calculating...') {
        avalnaCalculateDelivery();
      }
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', avalnaInitCartTrust);
  } else {
    avalnaInitCartTrust();
  }
})();
